import { render, staticRenderFns } from "./CustomerDistribution.vue?vue&type=template&id=685036e9"
import script from "./CustomerDistribution.vue?vue&type=script&lang=js"
export * from "./CustomerDistribution.vue?vue&type=script&lang=js"
import style0 from "./CustomerDistribution.vue?vue&type=style&index=0&id=685036e9&lang=scss&scope=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('685036e9')) {
      api.createRecord('685036e9', component.options)
    } else {
      api.reload('685036e9', component.options)
    }
    module.hot.accept("./CustomerDistribution.vue?vue&type=template&id=685036e9", function () {
      api.rerender('685036e9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/sfe/performanceReport/components/CustomerDistribution.vue"
export default component.exports